import {defaultSelectedTipoSeguimiento, filtro} from "./state";

// lista tipos de seguimiento
export function setListarTipoSeguimiento(state, tipoSeguimientos) {
  state.tipoSeguimientos = tipoSeguimientos
}

// muestra un tipo de seguimieno
export function setTipoSeguimiento(state, tipoSeguimiento) {
  state.selectedTipoSeguimiento = tipoSeguimiento
}

export function setAccion(state, action) {
  state.accion = action;
}

export function setPage(state, page) {
  state.filtro.page = page
}

//limpia campos
export function resetSelectedTipoSeguimiento(state) {
  Object.assign(state.selectedTipoSeguimiento, defaultSelectedTipoSeguimiento())
}

/**
 * Limpiar filtros
 */
export function resetFilters(state) {
  Object.assign(state.filtro, filtro());
}
